/**
 * Single source of truth for INSi identity-reliability status colours.
 *
 * Status drives the colour everywhere it appears — the patients-list badge, the
 * record INS card, and the locked identity card — so the palette tokens are
 * mapped here once and imported by all of them. Orange = Provisoire,
 * blue = Récupérée, green = Qualifiée. `accent` is the line/text colour, `bg`
 * the light tint behind it.
 */
import colors from 'lib/colors';

export const INSI_STATUS_COLORS = {
  PROVISOIRE: {
    accent: colors.statusInsiProvisoire,
    bg: colors.statusInsiProvisoireBg,
  },
  RECUPEREE: {
    accent: colors.statusInsiRecuperee,
    bg: colors.statusInsiRecupereeBg,
  },
  QUALIFIEE: {
    accent: colors.statusInsiQualifiee,
    bg: colors.statusInsiQualifieeBg,
  },
};

export default INSI_STATUS_COLORS;
